export default __webpack_public_path__ + "static/media/overlay-background.de3d59c2.jpg";